export default __webpack_public_path__ + "static/fargevekting-ikke-lov-b187f2652a509f4d102721f67e08cf03.png";